import { memo } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Dialog } from "primereact/dialog";
import { useCrad } from "../../Hooks/Features/aglieKanban/useCard";
import { AgGridReact } from "@ag-grid-community/react";

const Cards = ({ id, task, status, key, option, handleChange, setShowPopup, selectedTaskIds, setSelectedTaskIds }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
    const { reviewPopup, setReviewPopup, colDef } = useCrad()
    const isSelected = selectedTaskIds?.has(id);

    const onCheckboxChange = (e) => {
        e.stopPropagation();
        const checked = e.target.checked;
        setSelectedTaskIds(prev => {
            const newSet = new Set(prev);
            if (checked) {
                newSet.add(id);
            } else {
                newSet.delete(id);
            }
            return newSet;
        });
    };

    return (
        <div className="w20 px-1">
            <div className={`kanban-board-card agile-card ${isSelected ? "selected" : ""}`} ref={setNodeRef} style={{
                transform: CSS.Translate.toString(transform), transition, backgroundColor: isDragging ? "#white" : "white",
            }} {...attributes} {...listeners} key={key} onClick={(e) => {
                if (!isDragging) {
                    e.stopPropagation()
                    setShowPopup({ show: true, data: task });
                }
            }}>
                <div className="d-flex gap-2 align-items-start">
                    <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={onCheckboxChange}
                        onClick={e => e.stopPropagation()}
                        className="c-pointer px-2"
                    />
                    <span className="task-summary" style={{ wordBreak: "break-all" }}>
                        {task?.issue_summary}
                    </span>
                </div>

                <div>
                    {
                        <div className="parent text-truncate" style={{ visibility: task?.feature_issue_summary?.length > 0 ? "" : "hidden" }}>
                            {task?.feature_issue_summary}
                        </div>
                    }
                </div>
                <div>
                    {
                        status === "Planning" && <div className="d-flex justify-content-between w100 " onClick={e => e.stopPropagation()}>
                            <select
                                className="input-dd w50"
                                value={task?.complexity_id || {}}
                                onChange={(e) => handleChange(e.target?.value, task, "complexity_id")}
                                onPointerDown={e => e.stopPropagation()}
                            >
                                <option value="">Complexity</option>
                                {option?.complexity.map(opt => (
                                    <option key={opt.issue_complexity_id} value={opt.issue_complexity_id}>{opt.issue_complexity_name}</option>
                                ))}
                            </select>
                            <select
                                className="input-dd w50"
                                value={task?.longitivity_id || {}}
                                onChange={(e) => handleChange(e.target?.value, task, "longitivity_id")}
                                onPointerDown={e => e.stopPropagation()}
                            >
                                <option value="">Logitivity_</option>
                                {option?.logitivity?.map((opt, index) => (
                                    <option key={index} value={opt.issue_logitivity_id}>{opt.issue_logitivity_name}</option>
                                ))}
                            </select>
                        </div>
                    }
                    {
                        (status === "Estimating" || status === "In Finalize") && <div className="">
                            {
                                task?.bid_list?.slice(0, 1)?.map((value, index) => {
                                    return <div className="d-flex justify-content-between w100 mt-1" key={index}>
                                        <span>{value?.user_display_name}</span>
                                        <span className="rounded  px-2" style={{ background: "#3441f5ff", color: "#fff" }}>{value?.bid_seconds / 3600}h</span>
                                    </div>
                                })
                            }
                            {
                                task?.bid_list?.length >= 2 && <div onClick={(e) => { e.stopPropagation(); setReviewPopup({ view: true, data: task }) }} className="text-primary c-pointer text-right">View More</div>
                            }
                        </div>
                    }
                    <div className="d-flex justify-content-between align-items-end py-1">
                        <div className="fw-semibold" style={{ fontSize: "13px" }}>{task?.issue_key}</div>
                        <div className="text-muted" style={{ fontSize: "13px" }} title={task?.bucket_name}><p>{task?.bucket_name?.length > 20 ? task?.bucket_name?.slice(0, 20) + '...' : task?.bucket_name}</p></div>
                    </div>
                </div>
            </div>
            <Dialog visible={reviewPopup?.view} onHide={() => setReviewPopup({
                view: false,
                data: []
            })} className='modal-small'
                style={{ height: "50vh" }}
                modal={true} draggable={false} header={() => <div>Bided Memeber List</div>}>
                <div className="ag-theme-alpine aggrid-container" style={{ height: "200px" }}>
                    <AgGridReact
                        rowData={reviewPopup?.data?.bid_list}
                        columnDefs={colDef}
                        rowHeight={30}
                        headerHeight={40} />
                </div>
            </Dialog>
        </div>
    );
}
export default memo(Cards);